import { requester } from "App";
import P from "components/P";
import Container from "layouts/container/Container";
import { useEffect, useState } from "react";
import style from "./StoreConfirmYnManagement.module.css";
import CustomButton from "components/buttons/CustomButton";
import { toast } from "react-toastify";

function StoreConfirmYnManagement() {
    const [isMounted, setMounted] = useState(false);
    const [stores, setStores] = useState([]);
    const [activeIndex, setActiveIndex] = useState(null);

    useEffect(() => {
        setMounted(true);
    }, [])

    useEffect(() => {
        if (isMounted) {
            let data = {

            }
            requester.findAllByConfirmYn(data, (result) => {
                
                setStores(result.data);
            })
        }
    }, [isMounted])

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    }
    const onConfirmClick = (storeCode) => {
        
        let storeData = {
            storeCode: storeCode
        }
        requester.storeConfirm(storeData,(result) => {
            if(result.code === 0){
                setStores(result.data);
                toast.success("승인이 완료되었습니다.", {
                    autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                });
            }
        
        })
    }

    return (
        <Container>
            <Container maxWidth={1200}>
                <P>Store Confirm Yn Management</P>
                {
                    stores && stores.map((data, index) => (
                        <div className={style.accordion} key={index} >
                            <div className={style.accordionHeader} onClick={() => toggleAccordion(index)}>
                                <span>{data.storeName}</span>
                                <span>{activeIndex === index ? '-' : '+'}</span>
                            </div>
                            <div className={`${style.accordionContent} ${activeIndex === index ? style.show : ''}`}>
                                {
                                    data.machines.length > 0 ? (
                                        data.machines.map((machine, idx) => (
                                            <div>
                                                <P key={idx}>{machine.orderNo}</P>
                                                <P>{machine.deviceCode}</P>

                                            </div>
                                        ))
                                    ) : (
                                        <P className={style.noMachineMessage}>등록된 기기가 없습니다</P>
                                    )
                                }
                                {
                                    data.machines.length > 1 &&
                                    <CustomButton text={"승인"} onClick={() =>onConfirmClick(data.storeCode)} />
                                }
                            </div>
                        </div>
                    ))
                }
            </Container>
        </Container>
    );
}

export default StoreConfirmYnManagement;